import { jsx as _jsx } from "react/jsx-runtime";
const toCssDimension = (value) => {
    if (typeof value === 'number') {
        return value <= 1 ? `${value * 100}%` : `${value}px`;
    }
    return value;
};
const variantClasses = {
    line: 'nucleus-rounded',
    circle: 'nucleus-rounded-full',
};
export const Skeleton = ({ variant = 'line', width, height, size, className = '', dataTestId }) => {
    const style = {};
    if (variant === 'line') {
        style.width = width !== undefined ? toCssDimension(width) : '100%';
        style.height = height !== undefined ? toCssDimension(height) : undefined;
    }
    if (variant === 'circle') {
        const dim = toCssDimension(size !== null && size !== void 0 ? size : 40);
        style.width = dim;
        style.height = dim;
    }
    return (_jsx("div", { role: 'status', "aria-label": 'Loading', "data-testid": dataTestId, className: `
        nucleus-bg-neutral-300 nucleus-animate-pulse nucleus-flex-shrink-0 
        ${variantClasses[variant] || variantClasses.line} 
        ${variant === 'line' && !height ? 'nucleus-h-4' : ''} 
        ${className}
      `, style: style }));
};
//# sourceMappingURL=skeleton.component.js.map